import {Component, Output, EventEmitter, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {SidebarProvider} from './sidebar-provider';
import {AuthService} from '../../../utility/auth-service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
    sideBarList: any[]=[];
    tabBarList: any[] = [];
    userLoginType: string;
    isActive: boolean = false;
    collapsed: boolean = false;
    showMenu: string = '';
    pushRightClass: string = 'push-right';

    customCollapsedHeight: string = '30px';
    customExpandedHeight: string = '30px';

    @Output() collapsedEvent = new EventEmitter<boolean>();
    @Output() tabsEvent = new EventEmitter<boolean>();

    constructor(private translate: TranslateService, public router: Router, private provider: SidebarProvider, private auth: AuthService) {
        this.translate.addLangs(['en', 'fr', 'ur', 'es', 'it', 'fa', 'de']);
        this.translate.setDefaultLang('en');
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang.match(/en|fr|ur|es|it|fa|de/) ? browserLang : 'en');
        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });


    }

    ngOnInit() {
        this.tabBarList = JSON.parse(localStorage.getItem("tabBarList"));
        var data = {
            orgId: this.auth.getSession().ORG_ID,
            oprId: this.auth.getSession().OPR_ID,
            roleId: this.auth.getSession().app_role_id,
        }

        this.provider.getPages(JSON.stringify(data)).subscribe((list: any[]) => {
//            this.sideBarList = list;
            if (this.auth.getSession().userType != "Admin") {
//                console.log(list[0]);
                         console.log(this.sideBarList);
                        this.sideBarList.push(list[0]);
                         console.log(this.sideBarList);
            }
            else {
                this.sideBarList = list;
                console.log(this.sideBarList);
            }

           
        }, error => {
                console.log(error);
                if (error.error.status == 401) {
                    this.onLoggedout();
                }
            });

    }

    eventCalled() {
        this.isActive = !this.isActive;
    }

    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }

    toggleCollapsed() {
        this.collapsed = !this.collapsed;
        this.collapsedEvent.emit(this.collapsed);
    }

    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    rltAndLtr() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
    }

    changeLang(language: string) {
        this.translate.use(language);
    }

    onLoggedout() {
        localStorage.removeItem('isLoggedin');
        localStorage.clear();
        this.auth.removeSession();
        this.router.navigate(['/login']);
    }

    openMenu(page) {
//        if (!this.collapsed) {
            this.openTabs(page);
            this.toggleCollapsed();
//        }
    }

    openTabs(page) {
        console.log(page);
        this.tabBarList = JSON.parse(localStorage.getItem("tabBarList"));
        localStorage.setItem("routerUrl", page.adRolePageRoutingUrl)
        if (this.tabBarList != null) {
            if (this.tabBarList.length == 0) {
                this.tabBarList.push(page);
                localStorage.setItem("tabBarList", JSON.stringify(this.tabBarList));
                this.tabsEvent.emit(true);
                this.tabBarList = JSON.parse(localStorage.getItem("tabBarList"));
            }
            else {
                var data = this.tabBarList.find(tabPage => tabPage.id === page.id);
                if (!data) {
                    this.tabBarList.push(page);
                    localStorage.setItem("tabBarList", JSON.stringify(this.tabBarList));
                    this.tabsEvent.emit(true);
                    console.log("hiii");
                }
                else {
                    this.tabsEvent.emit(false);
                    console.log("hiii");
                }
            }
        }
        else {
            this.tabBarList = [];
            this.tabBarList.push(page);
            localStorage.setItem("tabBarList", JSON.stringify(this.tabBarList));
            this.tabsEvent.emit(true);
            this.tabBarList = JSON.parse(localStorage.getItem("tabBarList"));
        }
    }
    
    
        
    openCloseMenu(obj, mType){
        console.log(obj);
        console.log(mType);
        if(mType == "Main"){
            obj.openMenu = !obj.openMenu;
        }
        if(mType == "Master"){
            obj.openMasterMenu = !obj.openMasterMenu;
        }
        if(mType == "Transaction"){
            obj.openTransactionMenu = !obj.openTransactionMenu;
        }
        if(mType == "Reports"){
            obj.openReportsMenu = !obj.openReportsMenu;
        }
    }

}
